import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';

const PRICES_CO = {
  basic: { monthly: 29900, annual: 299000 },
  plus: { monthly: 39900, annual: 399000 },
  premium: { monthly: 59900, annual: 599000 },
};

const PRICES_VE = {
  basic: { monthly: 4.99, annual: 49.90 },
  plus: { monthly: 7.99, annual: 79.90 },
  premium: { monthly: 11.99, annual: 119.90 },
};

const WOMPI_LINKS = {
  basic: { monthly: 'https://checkout.wompi.co/l/hPSz90', annual: 'https://checkout.wompi.co/l/P62YIa' },
  plus: { monthly: 'https://checkout.wompi.co/l/vR9p76', annual: 'https://checkout.wompi.co/l/NNRoUh' },
  premium: { monthly: 'https://checkout.wompi.co/l/FNHPwd', annual: 'https://checkout.wompi.co/l/tfWlv6' },
};

const BINANCE_LINKS = {
  basic: { monthly: 'https://s.binance.com/wNcnAh1b', annual: 'https://s.binance.com/eIkZQBOc' },
  plus: { monthly: 'https://s.binance.com/mqAtjLiN', annual: 'https://s.binance.com/mAMLuPD0' },
  premium: { monthly: 'https://s.binance.com/AiZYNjH4', annual: 'https://s.binance.com/XWBL0pUv' },
};

const PLANS = [
  {
    id: 'basic',
    title: 'Básico',
    badge: null,
    intro: 'Incluye:',
    showSeparator: false,
    features: [
      'Tomar foto a todos los comprobantes (máx. 5 por carga).',
      'Vista detallada de transferencias.',
      'Agregar notas a las transferencias.',
      'Suma mensual de ingresos.',
      'Filtro por turnos y por rango de fechas.',
      'Administración de transferencias.',
      '4 perfiles de acceso (Admin, Contabilidad, Asesor 1 y 2).',
      '1 mes de almacenamiento de comprobantes (5 días extra para descargar).',
      'Soporte por correo.',
    ],
    buttonClass: 'btn__purple',
    buttonStyle: {},
  },
  {
    id: 'plus',
    title: 'Plus',
    badge: 'El más comprado',
    intro: 'Todo lo del Básico, más:',
    showSeparator: true,
    features: [
      'Hasta 10 fotos por carga.',
      'Exportar a PDF (Shifts).',
      'Acceso a Egresos.',
      '2 meses de almacenamiento de comprobantes (5 días extra para descargar).',
      'Soporte por WhatsApp (respuesta ≤ 24h).',
      '15 días gratis de prueba (sin tarjeta).',
    ],
    buttonClass: 'btn__purple',
    buttonStyle: {},
  },
  {
    id: 'premium',
    title: 'Premium',
    badge: 'Recomendado',
    intro: 'Todo lo del Plus, más:',
    showSeparator: true,
    features: [
      '5 perfiles de acceso (incl. Asesor 3).',
      '2 meses de almacenamiento de comprobantes (5 días extra para descargar).',
    ],
    buttonClass: '',
    buttonStyle: { backgroundColor: '#005bb5' },
  },
];

const PlanCard = ({ plan, price, paymentLink, priceSuffix, isVenezuela }) => {
  const isHighlight = plan.badge != null;
  const formattedPrice = isVenezuela
    ? `$${price.toFixed(2)}`
    : `$${price.toLocaleString('es-CO')}`;
  return (
    <div
      className={`rounded__12 p-4 h-100 shadow border position-relative d-flex flex-column w-100 ${isHighlight ? '' : 'shadow-sm'}`}
      style={{
        ...(isHighlight
          ? { backgroundColor: 'rgba(17, 112, 223, 0.08)', borderColor: 'rgb(17, 112, 223)', borderWidth: '2px' }
          : { backgroundColor: '#fff' }),
        overflow: 'visible',
      }}
    >
      {plan.badge && (
        <div
          className="position-absolute rounded-pill px-3 py-1 semi-bold font__size--12 text__12-1024 color__white"
          style={{
            top: '-12px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#005bb5',
            whiteSpace: 'nowrap',
            boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
          }}
        >
          {plan.badge}
        </div>
      )}
      <div className="mb-4 flex-grow-1">
        <h3 className="semi-bold font__size--24 text__24-1024 mb-2">{plan.title}</h3>
        <p className="mb-0">
          <span className="semi-bold font__size--28 text__28-1024 color__purple">
            {formattedPrice}
          </span>
          <span className="medium font__size--14 text__14-1024 color__gray-1 ml-1">{priceSuffix}</span>
        </p>
      </div>
      <div className="mb-4 flex-grow-1">
        <p className="semi-bold font__size--14 text__14-1024 mb-2">{plan.intro}</p>
        {plan.showSeparator && (
          <div className="text-center my-2" style={{ color: 'rgb(17, 112, 223)', fontSize: '20px' }}>▼</div>
        )}
        <ul className="list-unstyled medium font__size--14 text__14-1024 color__gray-1 lh-2 mb-0">
          {plan.features.map((f, i) => (
            <li key={i} className="mb-2">✅ {f}</li>
          ))}
        </ul>
      </div>
      <a
        href={paymentLink}
        rel="noopener noreferrer"
        target="_blank"
        className={`btn ${plan.buttonClass} px-4 color__white shadow rounded__12 w-100 semi-bold font__size--14 mt-auto text-center text-decoration-none d-block`}
        style={plan.buttonStyle}
      >
        {isVenezuela ? '🔶 Pagar con Binance Pay' : `Elegir ${plan.title}`}
      </a>
      {isVenezuela && (
        <p className="text-center mt-2 mb-0" style={{ fontSize: '11px', color: '#888' }}>
          Red TRC20 · Dirección: <strong>TXwqW5wwCpaaxxcnCRk5N8A6M7WXX6Bt2D</strong>
        </p>
      )}
    </div>
  );
};

const SecBlog = (props) => {
  const { user } = useAuth();
  const [billingPeriod, setBillingPeriod] = useState('monthly');
  const [mobileSlide, setMobileSlide] = useState(0);
  const [country, setCountry] = useState('CO');

  const isVenezuela = country === 'VE';
  const PRICES = isVenezuela ? PRICES_VE : PRICES_CO;

  const getPrice = (plan) => (billingPeriod === 'annual' ? PRICES[plan].annual : PRICES[plan].monthly);
  const getPaymentLink = (plan) => {
    if (isVenezuela) return BINANCE_LINKS[plan][billingPeriod];
    const base = WOMPI_LINKS[plan][billingPeriod];
    if (user?.email) return `${base}?email=${encodeURIComponent(user.email)}`;
    return base;
  };
  const priceSuffix = isVenezuela
    ? (billingPeriod === 'annual' ? ' USD/año' : ' USD/mes')
    : (billingPeriod === 'annual' ? ' COP/año' : ' COP/mes');

  const goPrev = () => setMobileSlide((s) => (s === 0 ? PLANS.length - 1 : s - 1));
  const goNext = () => setMobileSlide((s) => (s === PLANS.length - 1 ? 0 : s + 1));

  const arrowStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 2,
    width: 44,
    height: 44,
    borderRadius: '50%',
    border: '2px solid rgb(17, 112, 223)',
    background: '#fff',
    color: 'rgb(17, 112, 223)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.25rem',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  };

  return (
    <section>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="semi-bold font__size--72 text__70-1024 text__70-md text__70-sm mb-0">
            {props.title || 'Nuestros Planes'}
          </h2>
        </div>

        {/* Selector de País */}
        <div className="d-flex justify-content-center mb-3">
          <div
            className="d-inline-flex rounded-pill border overflow-hidden"
            style={{ borderColor: '#ccc' }}
          >
            <button
              type="button"
              className={`px-4 py-2 semi-bold font__size--14 border-0 ${country === 'CO' ? 'btn__purple color__white shadow' : 'bg-white'}`}
              style={country === 'CO' ? {} : { color: '#6c757d' }}
              onClick={() => setCountry('CO')}
            >
              🇨🇴 Colombia
            </button>
            <button
              type="button"
              className={`px-4 py-2 semi-bold font__size--14 border-0 ${country === 'VE' ? 'btn__purple color__white shadow' : 'bg-white'}`}
              style={country === 'VE' ? {} : { color: '#6c757d', borderLeft: '1px solid #ccc' }}
              onClick={() => setCountry('VE')}
            >
              🇻🇪 Venezuela
            </button>
          </div>
        </div>

        {isVenezuela && (
          <p className="text-center mb-3" style={{ fontSize: '13px', color: '#555' }}>
            Precios en USDT · Pago seguro con <strong>Binance Pay</strong>
          </p>
        )}

        {/* Selector Mensual / Anual */}
        <div className="d-flex justify-content-center mb-4">
          <div
            className="d-inline-flex rounded-pill border overflow-hidden"
            style={{ borderColor: 'rgb(17, 112, 223)' }}
          >
            <button
              type="button"
              className={`px-4 py-2 semi-bold font__size--14 border-0 ${billingPeriod === 'monthly' ? 'btn__purple color__white shadow' : 'bg-white'}`}
              style={billingPeriod === 'monthly' ? {} : { color: '#6c757d' }}
              onClick={() => setBillingPeriod('monthly')}
            >
              <span className="d-block">Mensual</span>
              <small className="d-block font__size--12" style={{ opacity: 0.9 }}>Pago cada mes</small>
            </button>
            <button
              type="button"
              className={`px-4 py-2 semi-bold font__size--14 border-0 border-left ${billingPeriod === 'annual' ? 'btn__purple color__white shadow' : 'bg-white'}`}
              style={billingPeriod === 'annual' ? {} : { color: '#6c757d', borderLeft: '1px solid rgb(17, 112, 223)' }}
              onClick={() => setBillingPeriod('annual')}
            >
              <span className="d-block">Anual</span>
              <small className="d-block font__size--12" style={{ opacity: 0.9 }}>Ahorras 2 meses</small>
            </button>
          </div>
        </div>

        {/* Desktop/Tablet: 3 columnas */}
        <div className="row justify-content-center d-none d-md-flex overflow-visible">
          {PLANS.map((plan) => (
            <div key={plan.id} className="col-lg-4 col-md-6 mb-4 d-flex">
              <PlanCard
                plan={plan}
                price={getPrice(plan.id)}
                paymentLink={getPaymentLink(plan.id)}
                priceSuffix={priceSuffix}
                isVenezuela={isVenezuela}
              />
            </div>
          ))}
        </div>

        {/* Mobile: carrusel con flechas */}
        <div
          className="d-md-none position-relative px-5"
          style={{ minHeight: 460, overflow: 'visible', paddingTop: '18px' }}
        >
          <button
            type="button"
            aria-label="Plan anterior"
            onClick={goPrev}
            style={{ ...arrowStyle, left: 8 }}
          >
            ‹
          </button>
          <button
            type="button"
            aria-label="Plan siguiente"
            onClick={goNext}
            style={{ ...arrowStyle, right: 8 }}
          >
            ›
          </button>
          <div style={{ overflow: 'visible' }}>
            {PLANS.map((plan, index) => (
              <div
                key={plan.id}
                style={{
                  display: index === mobileSlide ? 'block' : 'none',
                }}
              >
                <div className="d-flex" style={{ overflow: 'visible' }}>
                  <PlanCard
                    plan={plan}
                    price={getPrice(plan.id)}
                    paymentLink={getPaymentLink(plan.id)}
                    priceSuffix={priceSuffix}
                    isVenezuela={isVenezuela}
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="d-flex justify-content-center align-items-center mt-3" style={{ gap: '14px' }}>
            {PLANS.map((_, i) => (
              <button
                key={i}
                type="button"
                aria-label={`Ir al plan ${i + 1}`}
                onClick={() => setMobileSlide(i)}
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  border: 'none',
                  padding: 0,
                  background: i === mobileSlide ? 'rgb(17, 112, 223)' : '#ccc',
                  cursor: 'pointer',
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecBlog;
